var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWarningDiamondRedIcon = function SvgWarningDiamondRedIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#A2191F",
    d: "M14.708 7.295 8.705 1.291a1 1 0 0 0-1.41 0l-6 6.004a1 1 0 0 0 0 1.41l6.003 6.004a1 1 0 0 0 1.41 0l6.003-6.004a1 1 0 0 0 0-1.41zM7.5 5a.5.5 0 0 1 1 0v3.5a.5.5 0 1 1-1 0zm.5 6.5A.75.75 0 1 1 8 10a.75.75 0 0 1 0 1.5"
  })));
};
export default SvgWarningDiamondRedIcon;